/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_PauseInputs */

const en_us2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause workout`)
};

const pt_br2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar treino`)
};

const es_419_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar entrenamiento`)
};

const pt_pt2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar treino`)
};

const fr_fr2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en pause`)
};

const de_de2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training pausieren`)
};

const it_it2_workout_live_pause = /** @type {(inputs: Workout_Live_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti in pausa`)
};

/**
* | output |
* | --- |
* | "Pause workout" |
*
* @param {Workout_Live_PauseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_pause = /** @type {((inputs?: Workout_Live_PauseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_PauseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_pause(inputs)
	if (locale === "es-419") return es_419_workout_live_pause(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_pause(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_pause(inputs)
	if (locale === "de-DE") return de_de2_workout_live_pause(inputs)
	if (locale === "it-IT") return it_it2_workout_live_pause(inputs)
	return en_us2_workout_live_pause(inputs)
});
export { workout_live_pause as "workout-live.pause" }